import SummarizedInventoryReport from "../../../components/reports/summarizedInventoryReport";



const Index = () => {
    return <SummarizedInventoryReport/>
}

export default Index;